import { useQuery } from '@tanstack/react-query';

import useUrl from '~/common/hooks/useUrl';
import { typedApiClient } from '~/common/util/api-client';
import { createBlobUrl } from '~/common/util/pdfUtils';

export const useGetPDFUrl = (currentDocId) => {
  const { obfuscatedLoanIdentifier } = useUrl();
  const parsedDocId = Number(currentDocId);
  const hasValidDocId =
    currentDocId !== null &&
    currentDocId !== undefined &&
    currentDocId !== '' &&
    !Number.isNaN(parsedDocId);
  const isEnabled = hasValidDocId && parsedDocId !== 0;

  const fetchPDFUrl = async function () {
    const { data: pdfBuffer } =
      await typedApiClient.v1.classifyDocumentsGetDocumentPdfDetail(
        obfuscatedLoanIdentifier.obfuscatedLenderDatabaseId,
        obfuscatedLoanIdentifier.obfuscatedLoanRecordId,
        parsedDocId,
        {
          format: 'arraybuffer',
        },
      );

    return createBlobUrl(pdfBuffer as any);
  };

  return useQuery({
    queryKey: ['getPDFUrl', currentDocId],
    queryFn: fetchPDFUrl,
    enabled: isEnabled,
    initialData: isEnabled ? undefined : 'noDocumentFound',
    staleTime: Infinity,
  });
};
